module.exports = __webpack_public_path__ + "img/icon4.54ed2f8a.gif";